var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ma-4"},[_c('v-row',[_c('NavBar')],1),_c('div',{staticClass:"centered-container"},[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.about)}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }